import { SettingsSubnav } from '@/components/Settings/SettingsSubnav'
import { Users } from '@/components/Settings/Users/Users'
import { LocationsList } from '@/components/Settings/Locations/LocationsList'
import { DomainsList } from '@/components/Settings/Workspace/Domains/DomainsList'
import { PhoneNumbersList } from '@/components/Settings/Workspace/PhoneNumbers/PhoneNumbersList'
import { DataSourcesList } from '@/components/Settings/DataSources/DataSourcesList'
import { ConnectionsList } from '@/components/Settings/Connections/ConnectionsList'
import { Section, SubSection, SectionHeading } from '@/components/ui/section'
import { ProfileSection } from '@/components/Settings/Account/Profile/ProfileSection'
import { LinkedAccountsList } from '@/components/Settings/Account/LinkedAccounts/LinkedAccountsList'
import { BillingProfilesList } from '@/components/Settings/Account/BillingProfiles/BillingProfilesList'
import { WorkspaceBillingSection } from '@/components/Settings/Workspace/WorkspaceBilling/WorkspaceBillingSection'
import { useEffect } from 'react'

const groups = [
	{
		id: 'account',
		label: 'Account Settings',
		items: [
			{ id: 'profile', label: 'Profile' },
			{ id: 'linked-accounts', label: 'Linked Accounts' },
			{ id: 'billing-profiles', label: 'Billing Profiles' },
		],
	},
	{
		id: 'workspace',
		label: 'Workspace Settings',
		items: [
			{ id: 'workspace-users', label: 'Users' },
			{ id: 'workspace-locations', label: 'Locations' },
			{ id: 'workspace-domains', label: 'Domains' },
			{ id: 'workspace-phone-numbers', label: 'Phone Numbers' },
			{ id: 'workspace-data-sources', label: 'Data Sources' },
			{ id: 'workspace-connections', label: 'Connections' },
			{ id: 'workspace-billing', label: 'Billing' },
		],
	},
]

export default function SettingsPage() {
	// If there is a hash on initial load, ensure we scroll to it
	useEffect(() => {
		const hash = window.location.hash.replace('#', '')
		if (hash) {
			setTimeout(() => {
				document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
			}, 0)
		}
	}, [])

		return (
		<div className="flex w-full h-full">
			<aside className="w-64 shrink-0 pt-6 pl-6 pr-2">
				<SettingsSubnav groups={groups} />
			</aside>
			<main className="flex-1 overflow-y-auto px-6">
				<Section id="account">
					<SectionHeading level="h2">Account Settings</SectionHeading>
					
					<SubSection id="profile" showSeparator={false}>
						<div className="flex flex-col gap-4">
							<SectionHeading className="mb-0">Profile</SectionHeading>
							<ProfileSection />
						</div>
					</SubSection>
					
					<SubSection id="linked-accounts" showSeparator={false}>
						<LinkedAccountsList />
					</SubSection>
					
					<SubSection id="billing-profiles" showSeparator={false}>
						<BillingProfilesList />
					</SubSection>
				</Section>
				
				<Section id="workspace">
					<SectionHeading level="h2">Workspace Settings</SectionHeading>
					
					<SubSection id="workspace-users" showSeparator={false}>
						<Users />
					</SubSection>
					
					<SubSection id="workspace-locations" showSeparator={false}>
						<LocationsList />
					</SubSection>
					
					<SubSection id="workspace-domains" showSeparator={false}>
						<DomainsList />
					</SubSection>
					
					<SubSection id="workspace-phone-numbers" showSeparator={false}>
						<PhoneNumbersList />
					</SubSection>
					
					<SubSection id="workspace-data-sources" showSeparator={false}>
						<DataSourcesList />
					</SubSection>
					
					<SubSection id="workspace-connections" showSeparator={false}>
						<ConnectionsList />
					</SubSection>
					
					<SubSection id="workspace-billing" showSeparator={false}>
						<div className="flex flex-col gap-4">
							<SectionHeading className="mb-0">Billing</SectionHeading>
							<WorkspaceBillingSection />
						</div>
					</SubSection>
				</Section>
			</main>
		</div>
	)
}


